module.exports = __webpack_public_path__ + "static/sport/bgi-form-login.19723f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport5/bgi-form-login.png
// module id = 7J2L
// module chunks = 0